import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import {
  addPersistentData,
  getAuthenticateData,
  removePersistentData,
} from '../../library/helpers/utility';

const setInitialState = () => {
  let jsonData = getAuthenticateData();
  if (!_.isNil(jsonData)) {
    return {
      authenticate: jsonData.authenticate,
      rememberMe: jsonData.remember,
      isLoggedIn: true,
    };
  } else {
    return {
      authenticate: null,
      rememberMe: false,
      isLoggedIn: false,
    };
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: setInitialState(),
  reducers: {
    handleLogin: (state, action) => {
      addPersistentData(action.payload);
      state.authenticate = action.payload.authenticate;
      state.remember = action.payload.remember;
      state.isLoggedIn = true;
    },
    handleLogout: (state) => {
      removePersistentData();
      state.authenticate = null;
      state.rememberMe = null;
      state.isLoggedIn = false;
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
